(function () {
  'use strict';

  let localLinks = document.querySelectorAll("[href^='#']");
  let hash = window.location.hash;
  let anchor = null;
  if (hash) {
    let id = hash.substring(1);
    anchor = document.getElementById(id);
  }

  function Accordion(accordion) {
    let multiselect = accordion.getAttribute('data-multiselect') === 'true';
    let current = null;
    let sheets = accordion.children;

    // All trigger buttons as an array
    function getTriggers() {
      return Array.from(sheets).map(function (sheet) {
        return sheet.querySelector('.accordion-trigger');
      }).filter(Boolean);
    }

    function openSheet(sheet) {
      sheet.classList.add('active');
      let btn = sheet.querySelector('.accordion-trigger');
      let panel = btn ? document.getElementById(btn.getAttribute('aria-controls')) : null;
      if (btn) btn.setAttribute('aria-expanded', 'true');
      if (panel) panel.removeAttribute('hidden');
    }

    function closeSheet(sheet) {
      sheet.classList.remove('active');
      let btn = sheet.querySelector('.accordion-trigger');
      let panel = btn ? document.getElementById(btn.getAttribute('aria-controls')) : null;
      if (btn) btn.setAttribute('aria-expanded', 'false');
      if (panel) panel.setAttribute('hidden', '');
    }

    function toggle() {
      let sheet = this.closest('.accordion-item');
      if (multiselect) {
        if (sheet.classList.contains('active')) {
          closeSheet(sheet);
        } else {
          openSheet(sheet);
        }
      } else {
        if (current === sheet) {
          closeSheet(sheet);
          current = null;
        } else {
          if (current) closeSheet(current);
          openSheet(sheet);
          current = sheet;
        }
      }
    }

    // Arrow keys, Home, End
    function handleKeydown(event) {
      let triggers = getTriggers();
      let index = triggers.indexOf(document.activeElement);
      if (index === -1) return;

      switch (event.key) {
        case 'ArrowDown':
          event.preventDefault();
          triggers[(index + 1) % triggers.length].focus();
          break;
        case 'ArrowUp':
          event.preventDefault();
          triggers[(index - 1 + triggers.length) % triggers.length].focus();
          break;
        case 'Home':
          event.preventDefault();
          triggers[0].focus();
          break;
        case 'End':
          event.preventDefault();
          triggers[triggers.length - 1].focus();
          break;
      }
    }

    for (let i = 0; i < sheets.length; i++) {
      let sheet = sheets[i];
      let btn = sheet.querySelector('.accordion-trigger');

      if (sheet.querySelector('.sheet-header button')) {
        sheet.removeAttribute('tabindex');
      }

      // Synchronize initial state
      if (anchor && sheet.contains(anchor)) {
        if (!multiselect && current) closeSheet(current);
        openSheet(sheet);
        current = sheet;
      } else if (!multiselect && sheet.classList.contains('active')) {
        if (current) {
          closeSheet(sheet);
        } else {
          current = sheet;
        }
      }

      if (btn) {
        btn.addEventListener('click', toggle);
        btn.addEventListener('keydown', handleKeydown);
      }

      // Anchor links that point to content in the panel
      if (btn) {
        let ids = sheet.querySelectorAll('[id]');
        ids.forEach(function (el) {
          localLinks.forEach(function (link) {
            if (link.href.split('#')[1] === el.id) {
              link.addEventListener('click', function () {
                btn.click();
              });
            }
          });
        });
      }
    }

    // search filter
    let searchInput = document.querySelector(
      '.accordion-filter-input[data-target="' + accordion.getAttribute('id') + '"]'
    );
    if (searchInput) {
      searchInput.addEventListener('keyup', function (e) {
        let query = e.target.value.toLowerCase();
        for (let i = 0; i < sheets.length; i++) {
          if (sheets[i].textContent.toLowerCase().indexOf(query) > -1) {
            sheets[i].removeAttribute('hidden');
            sheets[i].classList.remove('hidden');
          } else {
            sheets[i].setAttribute('hidden', '');
          }
        }
      });
    }
  }

  let accordionList = document.querySelectorAll("ul[data-type='accordion']");
  accordionList.forEach(function (accordion) {
    new Accordion(accordion);
  });
})();
